import React from "react";
import ShowAllButton from "./HomeFeatured/ShowAllButton";

const BlogHeader = ({ page }) => {
  return (
    <div className="flex items-center justify-between mb-3 md:mb-10 sm:mb-5">
      <div className="flex items-center">
        <h2 className="text-themeBlack leading-normal text-[28px] font-medium">
          Blog Yazılarına <span className="font-light">Gözat</span>
        </h2>
      </div>
      <ShowAllButton
        url={page.url}
        title={page.title}
        styles="hidden sm:flex"
      />
    </div>
  );
};

export default BlogHeader;
